import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { trackApi } from '@/api';
import { QUERY_KEY_CONST } from '@/constant';
import type { TrackApi } from '@/type';

export const useGetTrackByFrameSeqQuery = (
  param?: Partial<TrackApi.GetTrackByFrameSeq.Request>,
) => {
  return useQuery({
    queryKey: QUERY_KEY_CONST.TRACK_KEYS.getTrackByFrameSeq(
      param as TrackApi.GetTrackByFrameSeq.Request,
    ),
    queryFn: () =>
      trackApi
        .getTrackByFrameSeq(param as TrackApi.GetTrackByFrameSeq.Request)
        .then(res => res.data.resultData),
    enabled: !!param?.taskID && !!param?.trackID,
    staleTime: 1000 * 30,
  });
};

export const useUpdateExpireTimeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (param: TrackApi.UpdateExpireTime.Request) =>
      trackApi.updateExpireTime(param),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY_CONST.FRAME_KEYS.getDetail(),
      });
    },
  });
};

export const useUpdateTrackIDMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (param?: TrackApi.UpdateTrackID.Request) =>
      trackApi.updateTrackID(param),
    onSuccess: (_, param) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY_CONST.TRACK_KEYS.getTrackByFrameSeq(param),
      });
    },
  });
};
